import React, { useEffect, useState, useRef } from "react";
import "./Usermaster.css";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@mui/lab/Autocomplete";
import Radio from "@mui/material/Radio";
import CommonButton from "../../../Componants/Common/Button";
import HeaderNavigation from "../../../Componants/Common/header Navigation/HeaderNavigation";
import {
  createUser,
  updateUser,
  toggleUserStatus,
  fetchUserList,
  getCityList,
  getServiceCenterList,
  getStateList,
} from "../../../API Service/apiService";
import CircularProgress from "@mui/material/CircularProgress";
import toast, { Toaster } from "react-hot-toast";
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import inactiveIcon from "../../../Assests/inactiveIcon.svg";
import activeIcon from "../../../Assests/activeIcon.svg";
import editIcon from "../../../Assests/editIcon.svg";


import Paginate from "../../../Componants/Common/Paginate";
import {
  Button,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Typography } from "@material-ui/core";
import Loader from "../../../Componants/Loader/Loader";
import { InputField } from "../../../Componants/Common/InputField";
import { EyeIcon } from "../../../Componants/Common/CustomEyeIcon";

const calltype = [];


const validationSchema = Yup.object({
  entityType: Yup.string().required("Entity type is required"),
  firstName: Yup.string()
    .max(50, "First name cannot exceed 50 characters")
    .required("First name is required"),
  lastName: Yup.string()
    .max(50, "Last name cannot exceed 50 characters")
    .required("Last name is required"),
  mobile: Yup.string()
    .matches(/^\d{10}$/, "Mobile number must be 10 digits")
    .required("Mobile number is required"),
  email: Yup.string().when("entityType", {
    is: "serviceCenter",
    then: () => Yup.string().email("Invalid email address").required("Email is required"),
    otherwise: () => Yup.string().email("Invalid email address").optional(),
  }),
  landline: Yup.string()
    .max(100, "Landline cannot exceed 100 characters")
    .optional(),
  addressLine1: Yup.string()
    .max(100, "Address Line 1 cannot exceed 100 characters")
    .required("Address Line 1 is required"),
  addressLine2: Yup.string()
    .max(100, "Address Line 2 cannot exceed 100 characters")
    .optional(),
  state: Yup.string().required("State is required"),
  city: Yup.string().required("City is required"),
  landmark: Yup.string().optional(),
  pincode: Yup.string()
    .matches(/^\d{6}$/, "Pincode must be 6 digits")
    .required("Pincode is required"),
  serviceCenter: Yup.string().when("entityType", {
    is: "serviceCenter",
    then: () => Yup.string().required("Service Center is required"),
    otherwise: () => Yup.string().optional(),
  }),
});

const Usermaster = () => {
  const formRef = useRef(null);
  const loggedInUserEntityType = localStorage.getItem("entityType");
  const isServiceCenterUser = loggedInUserEntityType && (
    loggedInUserEntityType.toLowerCase() === "servicecenter" || 
    loggedInUserEntityType.toLowerCase() === "servicecentre"
  );

  const [entityType, setEntityType] = useState(isServiceCenterUser ? "engineer" : "serviceCenter");
  const [selectedValue, setSelectedValue] = useState("ui"); // Default is "UI"
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [searchParams, setSearchParams] = useState({
    search: "",
    userId: "",
    page: 1,
    limit: 10,
    entityType: isServiceCenterUser ? "engineer" : "serviceCenter",
    mobile: "",
    email: ""
  });
  // const [totalRecords, setTotalRecords] = useState(0);
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordTable, setShowPasswordTable] = useState({});
  const [editUserId, setEditUserId] = useState(null);

  const [serviceCenterList, setServiceCenterList] = useState([]);
  const handleEntityChange = (e, val) => {
    if (val) {
      // Reset form and errors when entity type changes
      handleReset();
      fetchServiceCenterList();
      setEntityType(val.title);
      setValue(prev => ({
        ...prev,
        entityType: val.title,
        // Reset related fields
        serviceCenter: "",
        serviceCenterId: "",
        // Keep the state as is for serviceCenter type
        state: val.title === "serviceCenter" ? prev.state : "",
        stateId: val.title === "serviceCenter" ? prev.stateId : "",
        city: val.title === "serviceCenter" ? prev.city : "",
        cityId: val.title === "serviceCenter" ? prev.cityId : "",
      }));
    }
  };

  const handleChange = (event) => {
    setSelectedValue(event.target.value); // Only one radio button can be selected
  };

  // const [value, setValue] = useState({
  //   customerCompanyName: "",
  //   contactPersonName: "",
  //   email: "",
  //   mobileNo: "",
  // });

  const fetchServiceCenterList = async () => {
    try {
      const { data } = await getServiceCenterList();
      setServiceCenterList(data.serviceCenters);
      console.log("serviceCenterList", data.serviceCenters);
    } catch (error) {
      console.error("Error fetching service centers:", error);
      // alert(error.response.data.message)
      // toast.error(error.response.data.message)
    }
  };

// fetchServiceCenterList is now called in initializeData useEffect


  const handlePageChange = (newPage) => {
    setSearchParams(prev => ({
      ...prev,
      page: newPage
    }));
  };

  const handleSearchChange = (field, value) => {
    setSearchParams(prev => ({
      ...prev,
      [field]: value || "",
      page: 1
    }));
  };

  const handleSearch = () => {
    getUserList();
  };

  useEffect(() => {
    getUserList();
  }, [searchParams.page]);

  const handleEditClick = (row) => {
    setEditUserId(row._id);
    setEntityType(row.entityType || (isServiceCenterUser ? "engineer" : "serviceCenter"));
    setSelectedValue("ui");

    setValue({
      entityType: row.entityType || (isServiceCenterUser ? "engineer" : "serviceCenter"),
      firstName: row.firstName || "",
      lastName: row.lastName || "",
      mobile: row.mobile || "",
      email: row.email || "",
      landline: row.landline || "",
      addressLine1: row.addressLine1 || "",
      addressLine2: row.addressLine2 || "",
      state: row.state || "",
      stateId: row.stateId || "",
      city: row.city || "",
      cityId: row.cityId || "",
      landmark: row.landmark || "",
      pincode: row.pincode || "",
      serviceCenterId: row.serviceCenterId || "",
      password: row.password || "",
      loginID: row.loginID || "",
      serviceCenter: row.serviceCenter || "",
    });

    const matchingState = states.find(s => s._id === row.stateId || s.stateName === row.state) || null;
    setSelectedState(matchingState);

    const matchingCity = cities.find(c => c._id === row.cityId || c.cityName === row.city) || null;
    setSelectedCity(matchingCity);

    setErrors({});
    formRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const handleToggleStatus = async (row) => {
    try {
      setLoading(true);
      const response = await toggleUserStatus(row._id);
      if (response.data.status === "success") {
        toast.success(`User status updated successfully!`);
        getUserList();
      } else {
        toast.error(response.data.message || "Failed to update status");
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || "Failed to update status";
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    setValue({
      entityType: isServiceCenterUser ? "engineer" : "serviceCenter",
      firstName: "",
      lastName: "",
      mobile: "",
      email: "",
      landline: "",
      addressLine1: "",
      addressLine2: "",
      state: "",
      stateId: "",
      city: "",
      cityId: "",
      landmark: "",
      pincode: "",
      serviceCenterId: "",
      password: "",
      loginID: "",
      serviceCenter: "",
    });
    setErrors({});
    setSelectedState(null);
    setSelectedCity(null);
    setEntityType(isServiceCenterUser ? "engineer" : "serviceCenter");
    setEditUserId(null);
  };

  const handleSearchCancel = () => {
    const initialParams = {
      search: "",
      userId: "",
      page: 1,
      limit: 10,
      entityType: isServiceCenterUser ? "engineer" : "serviceCenter",
      mobile: "",
      email: ""
    };
    setSearchParams(initialParams);
    getUserList(initialParams);
  };

  const calltypeDefaultProps = {
    options: calltype,
    getOptionLabel: (option) => option.title,
  };

  const EntityType = isServiceCenterUser
    ? [{ title: "engineer", Value: 1 }]
    : [
        { title: "engineer", Value: 1 },
        { title: "serviceCenter", Value: 2 },
      ];

  const [isChecked1, setChecked1] = useState(false);
  const [isChecked2, setChecked2] = useState(false);


  const handleCheckboxChange1 = () => {
    setChecked1(!isChecked1);
  };

  const handleCheckboxChange2 = () => {
    setChecked2(!isChecked2);
  };

  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [tableData, setTableData] = useState([]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };

  const handleUpload = () => {
    if (selectedFile) {
      console.log("Uploading file:", selectedFile.name);
    } else {
      console.log("No file selected.");
    }
  };

  const shouldHideField = (field) => {
    if (entityType === "serviceCenter") {
      return field === "serviceCenter";
    } else if (entityType === "engineer") {
      return [
        "landline",
        "addressLine1",
        "addressLine2",
        "state",
        "city",
        "landmark",
        "pincode",
        "serviceCentertext",
      ].includes(field);
    }
    return false;
  };

  const [value, setValue] = useState({
    entityType: isServiceCenterUser ? "engineer" : "serviceCenter", // Set default entity type
    firstName: "",
    lastName: "",
    mobile: "",
    email: "",
    landline: "",
    addressLine1: "",
    addressLine2: "",
    state: "",
    stateId: "",
    city: "",
    cityId: "",
    landmark: "",
    pincode: "",
    serviceCenterId: "",
    password: "",
    loginID: "",
    serviceCenter: "",
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Add validation helper functions
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validateMobile = (mobile) => {
    const mobileRegex = /^\d{10}$/;
    return mobileRegex.test(mobile);
  };

  const validatePincode = (pincode) => {
    const pincodeRegex = /^\d{6}$/;
    return pincodeRegex.test(pincode);
  };

  const validateField = (fieldName, value) => {
    let error = '';

    if (!value || (typeof value === 'string' && value.trim() === '')) {
      if (fieldName === 'email' && entityType === 'engineer') {
        return '';
      }
      if (['landline', 'addressLine2', 'landmark'].includes(fieldName)) {
        return '';
      }
      error = `${fieldName} is required`;
    } else {
      switch (fieldName) {
        case 'email':
          if (!validateEmail(value)) {
            error = 'Please enter a valid email address';
          }
          break;
        case 'mobile':
          if (!validateMobile(value)) {
            error = 'Mobile number must be 10 digits';
          }
          break;
        case 'pincode':
          if (entityType === 'serviceCenter' && !validatePincode(value)) {
            error = 'Pincode must be a valid 6-digit number';
          }
          break;
        case 'password':
          if (value.length < 6) {
            error = 'Password must be at least 6 characters long';
          }
          break;
        case 'firstName':
        case 'lastName':
          if (value.length < 2) {
            error = `${fieldName} must be at least 2 characters long`;
          }
          break;
        case 'loginID':
          if (value.length < 4) {
            error = 'Login ID must be at least 4 characters long';
          }
          break;
        case 'serviceCenterId':
          if (entityType === 'engineer' && !value) {
            error = 'Please select a service center';
          }
          break;
        case 'serviceCenter':
          if (entityType === 'serviceCenter' && (!value || value.trim().length < 3)) {
            error = 'Service center name must be at least 3 characters long';
          }
          break;
        case 'state':
          if (entityType === 'serviceCenter' && !value) {
            error = 'Please select a state';
          }
          break;
        case 'city':
          if (entityType === 'serviceCenter' && !value) {
            error = 'Please select a city';
          }
          break;
        case 'addressLine1':
          if (entityType === 'serviceCenter' && value.trim().length < 5) {
            error = 'Address must be at least 5 characters long';
          }
          break;
        default:
          break;
      }
    }
    return error;
  };

  // Add real-time validation function
  const handleFieldValidation = (fieldName, value) => {
    const error = validateField(fieldName, value);
    setErrors(prev => ({
      ...prev,
      [fieldName]: error
    }));
    return !error;
  };

  // Update the onChange handlers for all fields to include validation
  const handleInputChange = (fieldName, value) => {
    setValue(prev => ({
      ...prev,
      [fieldName]: value
    }));
    handleFieldValidation(fieldName, value);
  };

  // Update Autocomplete components to include validation
  const handleStateChange = (event, newValue) => {
    setSelectedState(newValue);
    const stateName = newValue ? newValue.stateName : "";
    const stateId = newValue ? newValue._id : "";
    setValue(prev => ({
      ...prev,
      state: stateName,
      stateId: stateId,
      city: "" // Reset city when state changes
    }));
    // Reset selected city when state changes
    setSelectedCity(null);
  };

  const handleCityChange = (event, newValue) => {
    setSelectedCity(newValue);
    const cityName = newValue ? newValue.cityName : "";
    const cityId = newValue ? newValue._id : "";
    setValue(prev => ({
      ...prev,
      cityId: cityId,
      city: cityName
    }));
  };

  const handleServiceCenterChange = (event, newValue) => {
    const serviceCenterId = newValue ? newValue._id : "";
    setValue(prev => ({
      ...prev,
      serviceCenterId
    }));
    handleFieldValidation('serviceCenterId', serviceCenterId);
  };

  // Add validateForm function
  const validateForm = () => {
    const requiredFields = entityType === 'serviceCenter'
      ? [
        'entityType',
        'firstName',
        'lastName',
        'mobile',
        'email',
        'addressLine1',
        'state',
        'city',
        'pincode',
        'password',
        'loginID',
        'serviceCenter'
      ]
      : [
        'entityType',
        'firstName',
        'lastName',
        'mobile',
        'serviceCenterId',
        'password',
        'loginID'
      ];

    const newErrors = {};
    let isValid = true;

    // Validate all required fields
    requiredFields.forEach(field => {
      const error = validateField(field, value[field]);
      if (error) {
        newErrors[field] = error;
        isValid = false;
      }
    });

    // Set all errors at once
    setErrors(newErrors);
    return isValid;
  };

  const handleSave = async () => {
    try {
      setIsSubmitting(true);

      const isValid = validateForm();
      if (!isValid) {
        setIsSubmitting(false);
        return;
      }

      setLoading(true);
      const data = value;

      let response;
      if (editUserId) {
        response = await updateUser(editUserId, data);
      } else {
        response = await createUser(data);
      }

      if (response.data.status === "success") {
        toast.success(`${entityType} ${editUserId ? "updated" : "created"} successfully!`);
        handleCancel();
        getUserList();
      } else {
        toast.error(response.data.message || "Operation failed");
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || "Failed to save data";
      toast.error(errorMessage);
    } finally {
      setLoading(false);
      setIsSubmitting(false);
    }
  };

  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const [selectedState, setSelectedState] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);

  const fetchState = async () => {
    try {
      setLoading(true);
      const response = await getStateList();
      setStates(response.data.states);
    } catch (error) {
      console.error("Error fetching states:", error);
      toast.error("Failed to load states. Please try again.");
    } finally {
      setLoading(false);
    }
  };
  const fetchCities = async () => {
    try {
      setLoading(true);
      const response = await getCityList();
      setCities(response.data.cities);
      console.log("response.data", response.data);
      setTotalRecords(response.data.totalCities);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching countries:", error);
    }
  };

  const getUserList = async (params = searchParams) => {
    try {
      setLoading(true);
      const response = await fetchUserList(params);
      console.log("response", response);
      if (response.data.status === "success") {
        setTableData(response.data.data.users);
        setTotalRecords(response.data.data.pagination.totalUsers || 0);
      }
      else {
        toast.error(response.data.message || "Failed to fetch user list");
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || "Failed to create user";
      console.error("Error fetching user list:", error);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const initializeData = async () => {
      setLoading(true);
      try {
        await Promise.all([fetchState(), fetchCities(), fetchServiceCenterList()]);
      } catch (error) {
        console.error("Error initializing data:", error);
        toast.error("Failed to initialize data. Please refresh the page.");
      } finally {
        setLoading(false);
      }
    };

    initializeData();
  }, []);
  const filteredCities = selectedState
    ? cities.filter((city) => city.stateName === selectedState.stateName)
    : [];
  const [userList, setUserList] = useState([]);
  const handleReset = () => {
    // Reset all form fields
    setValue({
      entityType: isServiceCenterUser ? "engineer" : "serviceCenter", // Set default entity type
      firstName: "",
      lastName: "",
      mobile: "",
      email: "",
      landline: "",
      addressLine1: "",
      addressLine2: "",
      state: "",
      stateId: "",
      city: "",
      landmark: "",
      pincode: "",
      serviceCenterId: "",
      password: "",
      loginID: "",
      serviceCenter: "",
    });

    // Reset all error states
    setErrors({});

    // Reset state selection
    setSelectedState(null);

    // Reset entity type to default if needed
    setEntityType(isServiceCenterUser ? "engineer" : "serviceCenter");

    // Reset loading and submitting states
    setLoading(false);
    setIsSubmitting(false);
    setEditUserId(null);
  };

  const showPasswordVisibility = () => {
    setShowPassword(true);
  };
  const hidePasswordVisibility = () => {
    setShowPassword(false);
  };

  return (
    <>
      <div className="container-Usermaster" ref={formRef}>
        <HeaderNavigation value={"User Master"} location={"/setting"} />
        <Toaster position="top-center" reverseOrder={false} />
        <div className="content-Usermaster">
          {loading && <Loader />}
          {/* <div className="Usermaster-container" style={{ padding: '15px', backgroundColor: '#eff3fe', margin: '10px', borderRadius: '4px', boxShadow: '0 1px 3px rgba(0,0,0,0.12)' }}>
            <div className="createuu-Usermaster" style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
              <h4 style={{ margin: 0, fontSize: '16px', color: '#333' }}>Create User Using:</h4>
              <div className="rediobutton-Usermaster" style={{ display: 'flex', gap: '20px' }}>
                <div className="first-rediobutton-Usermaster" style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                  <Radio
                    checked={selectedValue === "excel"}
                    onChange={handleChange}
                    value="excel"
                    name="radio-buttons"
                    inputProps={{ "aria-label": "Excel" }}
                    size="small"
                  />
                  <p style={{ margin: 0, fontSize: '14px' }}>Excel</p>
                </div>
                <div className="secound-rediobutton-Usermaster" style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                  <Radio
                    checked={selectedValue === "ui"}
                    onChange={handleChange}
                    value="ui"
                    name="radio-buttons"
                    inputProps={{ "aria-label": "UI" }}
                    size="small"
                  />
                  <p style={{ margin: 0, fontSize: '14px' }}>UI</p>
                </div>
              </div>
            </div>
          </div> */}

          {selectedValue === "ui" && (
            <div className="ui-Usermaster">
              <div className="text-auti-form-Usermaster">
                <div className="line-Usermaster">
                  <div className="textinput-Usermaste">
                    <Autocomplete
                      options={EntityType}
                      getOptionLabel={(option) => option.title}
                      value={EntityType.find((opt) => opt.title === entityType) || null}
                      onChange={handleEntityChange}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Entity Type"
                          variant="standard"
                          required
                          error={!!errors.entityType}
                          helperText={errors.entityType}
                        />
                      )}
                    />
                  </div>

                  {entityType === "serviceCenter" && (
                    <div className="textinput-Usermaste">
                      <TextField
                        id="standard-basic"
                        label="Service Center Name"
                        variant="standard"
                        required
                        error={!!errors.serviceCenter}
                        helperText={errors.serviceCenter}
                        value={value.serviceCenter || ''}
                        onChange={(e) => {
                          setValue({ ...value, serviceCenter: e.target.value });
                          if (errors.serviceCenter) {
                            setErrors({ ...errors, serviceCenter: '' });
                          }
                        }}
                      />
                    </div>
                  )}

                  {entityType === "engineer" && (
                    <div className="textinput-Usermaste">
                      <Autocomplete
                        options={serviceCenterList}
                        getOptionLabel={(option) =>
                          option.serviceCenter || "no service center"
                        }
                        value={serviceCenterList.find((sc) => sc._id === value.serviceCenterId) || null}
                        onChange={handleServiceCenterChange}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Service Center"
                            variant="standard"
                            required
                            error={!!errors.serviceCenterId}
                            helperText={errors.serviceCenterId}
                          />
                        )}
                      />
                    </div>
                  )}

                  <div className="textinput-Usermaste"></div>
                  <div className="textinput-Usermaste"></div>
                </div>

                <div className="line-Usermaster">
                  <div className="textinput-Usermaste">
                    <TextField
                      id="standard-basic"
                      label="Login ID"
                      variant="standard"
                      required
                      error={!!errors.loginID}
                      helperText={errors.loginID}
                      value={value.loginID || ''}
                      onChange={(e) => {
                        setValue({ ...value, loginID: e.target.value });
                        if (errors.loginID) {
                          setErrors({ ...errors, loginID: '' });
                        }
                      }}
                    />
                  </div>
                  <div className="textinput-Usermaste" style={{ display: "flex", alignItems: "end"}}>
                    <TextField
                    // style={{ width: "100%" }}
                      id="standard-basic"
                      label="Password"
                      variant="standard"
                      type={showPassword ? "text" : "password"}
                      required
                      error={!!errors.password}
                      helperText={errors.password}
                      value={value.password || ''}
                      onChange={(e) => {
                        setValue({ ...value, password: e.target.value });
                        if (errors.password) {
                          setErrors({ ...errors, password: '' });
                        }
                      }}
                    />
                    {/* {
              showPassword ? <VisibilityIcon sx={{ marginLeft: "0px", cursor:"pointer" }} onClick={showPasswordVisibility} /> : <VisibilityOffIcon sx={{ marginLeft: "0px", cursor:"pointer" }} onClick={showPasswordVisibility} />
            } */}
                    <EyeIcon
                      showPassword={showPassword}
                      showPasswordVisibility={showPasswordVisibility}
                      hidePasswordVisibility={hidePasswordVisibility}
                      // position="absolute"
                      // right="50px"
                      // top="50%"
                      // transform="translateY(-50%)"
                    />
                  </div>
                  {/* <InputField
                   className="textinput-Usermaste"
                   label="Password"
                   variant="standard"
                   type={showPassword ? "text" : "password"}
                   required
                   error={!!errors.password}
                   helperText={errors.password}
                   value={value.password || ''}
                   onChange={(e) => {
                     setValue({ ...value, password: e.target.value });
                     if (errors.password) {
                       setErrors({ ...errors, password: '' });
                     }
                   }}
                   showPassword={showPassword}
                   showPasswordVisibility={showPasswordVisibility}
                  /> */}
                  <div className="textinput-Usermaste"></div>
                  <div className="textinput-Usermaste"></div>
                </div>

                <div className="line-Usermaster">
                  <div className="textinput-Usermaste">
                    <TextField
                      id="firstName"
                      name="firstName"
                      label="First Name"
                      variant="standard"
                      required
                      error={!!errors.firstName}
                      helperText={errors.firstName}
                      value={value.firstName || ''}
                      onChange={(e) => handleInputChange('firstName', e.target.value)}
                    />
                  </div>
                  <div className="textinput-Usermaste">
                    <TextField
                      id="lastName"
                      name="lastName"
                      label="Last Name"
                      variant="standard"
                      required
                      error={!!errors.lastName}
                      helperText={errors.lastName}
                      value={value.lastName || ''}
                      onChange={(e) => handleInputChange('lastName', e.target.value)}
                    />
                  </div>
                  <div className="textinput-Usermaste">
                    <TextField
                      id="mobile"
                      name="mobile"
                      label="Mobile"
                      variant="standard"
                      required
                      error={!!errors.mobile}
                      helperText={errors.mobile}
                      value={value.mobile || ''}
                      onChange={(e) => handleInputChange('mobile', e.target.value)}
                    />
                  </div>
                  <div className="textinput-Usermaste">
                    <TextField
                      id="email"
                      name="email"
                      label="Email"
                      variant="standard"
                      required={entityType === 'serviceCenter'}
                      error={!!errors.email}
                      helperText={errors.email}
                      value={value.email || ''}
                      onChange={(e) => handleInputChange('email', e.target.value)}
                    />
                  </div>
                </div>

                <div className="line-Usermaster" id="address-usermaster">
                  {!shouldHideField("landline") && (
                    <div className="textinput-Usermaste">
                      <TextField
                        id="landline"
                        name="landline"
                        label="Landline"
                        variant="standard"
                        value={value.landline || ''}
                        onChange={(e) => handleInputChange('landline', e.target.value)}
                      />
                    </div>
                  )}
                  {!shouldHideField("addressLine1") && (
                    <div className="textinput-Usermaste">
                      <TextField
                        id="addressLine1"
                        name="addressLine1"
                        label="Address Line 1"
                        variant="standard"
                        required
                        error={!!errors.addressLine1}
                        helperText={errors.addressLine1}
                        value={value.addressLine1 || ''}
                        onChange={(e) => handleInputChange('addressLine1', e.target.value)}
                      />
                    </div>
                  )}
                  {!shouldHideField("addressLine2") && (
                    <div className="textinput-Usermaste">
                      <TextField
                        id="addressLine2"
                        name="addressLine2"
                        label="Address Line 2"
                        variant="standard"
                        error={!!errors.addressLine2}
                        helperText={errors.addressLine2}
                        value={value.addressLine2 || ''}
                        onChange={(e) => handleInputChange('addressLine2', e.target.value)}
                      />
                    </div>
                  )}
                  {!shouldHideField("state") && (
                    <div className="textinput-Usermaste">
                      <Autocomplete
                        options={states}
                        getOptionLabel={(option) => option.stateName}
                        value={selectedState}
                        onChange={handleStateChange}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="State"
                            variant="standard"
                            required
                            error={!!errors.state}
                            helperText={errors.state}
                          />
                        )}
                      />
                    </div>
                  )}
                </div>

                <div className="line-Usermaster">
                  {!shouldHideField("city") && (
                    <div className="textinput-Usermaste">
                      <Autocomplete
                        options={filteredCities}
                        getOptionLabel={(option) => option.cityName}
                        value={selectedCity}
                        onChange={handleCityChange}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="City"
                            variant="standard"
                            required
                            error={!!errors.city}
                            helperText={errors.city}
                          />
                        )}
                      />
                    </div>
                  )}
                  {!shouldHideField("landmark") && (
                    <div className="textinput-Usermaste">
                      <TextField
                        id="landmark"
                        name="landmark"
                        label="Landmark"
                        variant="standard"
                        error={!!errors.landmark}
                        helperText={errors.landmark}
                        value={value.landmark || ''}
                        onChange={(e) => handleInputChange('landmark', e.target.value)}
                      />
                    </div>
                  )}
                  {!shouldHideField("pincode") && (
                    <div className="textinput-Usermaste">
                      <TextField
                        id="pincode"
                        name="pincode"
                        label="Pincode"
                        variant="standard"
                        required
                        error={!!errors.pincode}
                        helperText={errors.pincode}
                        value={value.pincode || ''}
                        onChange={(e) => handleInputChange('pincode', e.target.value)}
                      />
                    </div>
                  )}
                  {!shouldHideField("") && (
                    <div className="textinput-Usermaste"></div>
                  )}
                </div>

                <div className="button-container-Usermaster">
                  <div className="button-Usermaster">
                    <CommonButton
                      name={"SAVE"}
                      handleOnClick={handleSave}
                      disabled={isSubmitting || loading}
                    />

                    <CommonButton
                      name={"CANCEL"}
                      handleOnClick={handleCancel}

                    />
                  </div>
                </div>
              </div>
            </div>

          )}
          <Grid
            container
            spacing={2}
            sx={{
              backgroundColor: "#eff3fe",
              padding: "20px",
              marginTop: "20px",
              marginLeft: "10px",
              marginRight: "10px",
              width: "calc(100% - 20px)", // Adjust width to account for margins
            }}
          >
            <Grid container>
              <Typography variant="h6">List View</Typography>
            </Grid>

            {/* Input Fields and Buttons in One Row */}
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={3}>
                <Autocomplete
                  {...calltypeDefaultProps}
                  options={EntityType}
                  value={EntityType.find(option => option.title === searchParams.entityType) || null}
                  onChange={(_, value) => handleSearchChange('entityType', value?.title || '')}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Entity Type"
                      variant="standard"
                      sx={{ width: '70%' }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  id="mobile"
                  name="mobile"
                  label="Mobile"
                  variant="standard"
                  value={searchParams.mobile || ''}
                  onChange={(e) => handleSearchChange('mobile', e.target.value)}
                />
              </Grid>
              <Grid item xs={3}>
                <TextField
                  id="email"
                  name="email"
                  label="Email"
                  variant="standard"
                  value={searchParams.email || ''}
                  onChange={(e) => handleSearchChange('email', e.target.value)}
                />
              </Grid>
              <Grid item xs={3} sx={{ display: "flex", gap: "10px" }}>
                <CommonButton name={"Search"} handleOnClick={handleSearch} />
                <CommonButton name={"CANCEL"} handleOnClick={handleSearchCancel} />
              </Grid>
            </Grid>

            {/* Table Section */}
            <TableContainer component={Paper} sx={{ marginTop: "20px" }}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    {[
                      "Entity Type",
                      "Name",
                      "State",
                      "City",
                      "Mobile No",
                      "Email",
                      "Login Id",
                      "Password",
                      "Action"
                    ].map((header, index) => (
                      <TableCell
                        key={index}
                        align={header === "Action" ? "center" : "left"}
                        sx={{
                          color: "#fff",
                        }}
                      >
                        {header}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {tableData.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={9} align="center" sx={{ py: 3 }}>
                        <Typography variant="body1" color="textSecondary">
                          No Data Available
                        </Typography>
                      </TableCell>
                    </TableRow>
                  ) : (
                    tableData.map((row) => (
                      <TableRow key={row._id}>

                        <TableCell>{row?.entityType || '--'}</TableCell>
                        {/* <TableCell>{`${row?.firstName || ''} ${row?.lastName || ''}`.trim() || '--'}</TableCell> */}
                        <TableCell>{row?.name || '--'}</TableCell>
                        <TableCell>{row?.state || '--'}</TableCell>
                        <TableCell>{row?.city || '--'}</TableCell>
                        <TableCell>{row?.mobile || '--'}</TableCell>
                        <TableCell>{row?.email || '--'}</TableCell>
                        <TableCell>{row?.loginID || '--'}</TableCell>
                        <TableCell align="center">
                          <div style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", gap: "8px", width: "100%" }}>
                            {row?.password ?
                              <>
                                <span>{showPasswordTable[row?.mobile] ? row?.password : "********"}</span>

                                <EyeIcon
                                  showPassword={showPasswordTable[row?.mobile]}
                                  showPasswordVisibility={() => setShowPasswordTable({ ...showPasswordTable, [row?.mobile]: true })}
                                  hidePasswordVisibility={() => setShowPasswordTable({ ...showPasswordTable, [row?.mobile]: false })}
                                // position="absolute"
                                // right="0px"
                                // top="50%"
                                // transform="translateY(-50%)"
                                />
                              </>

                              :
                              "--"
                            }
                          </div>
                        </TableCell>
                        <TableCell align="center">
                          <div style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", gap: "10px" }}>
                            <IconButton
                              onClick={() => handleToggleStatus(row)}
                              sx={{
                                outline: "none",
                                "&:focus": { outline: "none" },
                              }}
                            >
                              <img
                                src={row.active === false ? inactiveIcon : activeIcon}
                                alt="active"
                                height="20px"
                                width="20px"
                              />
                            </IconButton>

                            <IconButton
                              onClick={() => handleEditClick(row)}
                              sx={{
                                outline: "none",
                                "&:focus": { outline: "none" },
                              }}
                            >
                              <img
                                src={editIcon}
                                alt="Edit"
                                height={"20px"}
                                width={"20px"}
                              />
                            </IconButton>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Pagination */}
          </Grid>
          <div className="pagination-container" style={{ marginTop: '20px', display: 'flex', justifyContent: 'center' }}>
            <Paginate
              page={searchParams.page}
              totalRecords={totalRecords}
              onPageChange={handlePageChange}
              limit={searchParams.limit}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Usermaster;
